//#region src/backoff-strategy/helpers.ts
/**
* AWS-style "full jitter": returns a uniformly random delay in `[0, baseDelay]`.
* See https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
*/
const applyJitter = (baseDelay) => Math.round(Math.random() * baseDelay);
//#endregion
export { applyJitter };
